import { defineNuxtPlugin } from '#app';
import { useWebsiteStore } from '~/stores/websiteStore';

interface PageAnimationOptions {
  excludes: string[];
  fromName?: string;
  toName?: string;
}

export default defineNuxtPlugin((nuxtApp) => {
  const websiteStore = useWebsiteStore();
  const router = useRouter();

  const animationOptions: PageAnimationOptions = {
    excludes: ['cabinet'],
    fromName: undefined,
    toName: undefined,
  };

  router.afterEach((to, from, failure) => {
    animationOptions.fromName = typeof from.name === 'string' ? from.name : undefined;
    animationOptions.toName = typeof to.name === 'string' ? to.name : undefined;
  });

  nuxtApp.hook('page:loading:start', () => {
    const { fromName, toName, excludes } = animationOptions;

    const hasOverlap = excludes.some((exclude) => fromName?.includes(exclude) && toName?.includes(exclude));

    if (!hasOverlap) {
      // todo: временно закоментировал,
      // т.к. скрывается страница после navigateTo(query, { replace: true });
      websiteStore.pageHiddenPoint = true;
      websiteStore.blockTabBar = true;
    }
  });

  nuxtApp.hook('page:finish', () => {

    setTimeout(() => {
      websiteStore.pageHiddenPoint = false;
      websiteStore.disablePageAnimation = false;
      websiteStore.blockTabBar = false;
      websiteStore.backAnimation = false;
      websiteStore.hydrationComplete = true;
    }, 2);
  });

  nuxtApp.hook('page:loading:end', () => {

    setTimeout(() => {
      websiteStore.pageHiddenPoint = false;
      websiteStore.disablePageAnimation = false;
      websiteStore.blockTabBar = false;
      websiteStore.backAnimation = false;
      websiteStore.hydrationComplete = true;
    }, 2);
  });
});
